// extracted by mini-css-extract-plugin
export var legal = "Footer-module--legal--96308";
export var lowerFooter = "Footer-module--lowerFooter--8264b";
export var metaInfo = "Footer-module--metaInfo--20eb3";
export var padding = "Footer-module--padding--924a9";
export var root = "Footer-module--root--388e1";
export var social = "Footer-module--social--6e211";